// extracted by mini-css-extract-plugin
module.exports = {"page":"UsersAdd_page_z7S17","container":"UsersAdd_container_1A4Tp","box":"UsersAdd_box_1zJib","field":"UsersAdd_field_152hZ","multiselect":"UsersAdd_multiselect_2F-Wi"};